var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-values" },
    [
      _vm.education.educationCompletion
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Status der Ausbildung")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: {
                          characteristic: _vm.education.educationCompletion
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3340374705
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.workPermission
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Berufsberechtigung")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: { characteristic: _vm.education.workPermission }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2408279522
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.expertProfession
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Fachgebiet")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: {
                          characteristic: _vm.education.expertProfession
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1461678140
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.appraiserAuthorityEligible && _vm.education.appraiserAuthority
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Offizielle Befugnis")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _vm.education.appraiserAuthority.length === 0
                        ? _c("span", [_vm._v("Keine")])
                        : _c("LabelList", {
                            attrs: {
                              characteristics: _vm.extractCharacteristic(
                                _vm.education.appraiserAuthority
                              ),
                              "label-type": _vm.labelTypeApplication,
                              "last-level-only": ""
                            }
                          })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3074882445
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.educationCompletionType
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Abschluss durch")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: {
                          characteristic: _vm.education.educationCompletionType
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              159900
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.professions && _vm.education.professions.length > 0
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Fachliche Schwerpunkte")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("LabelList", {
                        attrs: {
                          characteristics: _vm.extractCharacteristic(
                            _vm.education.professions
                          ),
                          "label-type": _vm.labelTypeApplication,
                          "last-level-only": ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              487844548
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.validityEligible
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Gültigkeit")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _vm.education.validityDate
                        ? [
                            _vm._v(
                              "\n\t\t\t\tzeitlich beschränkt bis " +
                                _vm._s(
                                  _vm._f("dateByObject")(
                                    _vm.education.validityDate
                                  )
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        : [_vm._v("zeitlich unbeschränkt")]
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1965241137
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.gainedTitle
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Erworbener Titel")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [_vm._v(_vm._s(_vm.education.gainedTitle))]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1196749452
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.schoolLocation && _vm.education.schoolLocation.length > 0
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Ort/e der Ausbildung")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("LabelList", {
                        attrs: {
                          characteristics: _vm.extractCharacteristic(
                            _vm.education.schoolLocation
                          ),
                          "label-type": _vm.labelTypeApplication,
                          "last-level-only": ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3923569886
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.furtherInstitutionType
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Art des Ausbildungsinstitutes")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: {
                          characteristic: _vm.education.furtherInstitutionType
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2851565650
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isDefined(_vm.education.postgraduate)
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Postgraduale Ausbildung")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _vm._v(_vm._s(_vm.education.postgraduate ? "Ja" : "Nein"))
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3043211181
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isDefined(_vm.education.studyEntitlement)
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Studienberechtigung")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _vm._v(
                        _vm._s(_vm.education.studyEntitlement ? "Ja" : "Nein")
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3290066322
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.scopeCountriesEligible
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Geltungsbereich")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      !_vm.education.scopeCountries ||
                      _vm.education.scopeCountries.length === 0
                        ? _c("span", [_vm._v("Unbeschränkt")])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.education.scopeCountries
                                  .map(function(c) {
                                    return c.text
                                  })
                                  .join(" | ")
                              )
                            )
                          ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3140465711
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.education.details
        ? _c("div", {
            staticClass: "mt-2",
            domProps: { innerHTML: _vm._s(_vm.education.details) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }